import { Component } from '@angular/core';

@Component({
  selector: 'grow-allies-phrase',
  templateUrl: './grow-allies-phrase.component.html',
  styleUrls: ['./grow-allies-phrase.component.css']
})
export class GrowAlliesPhraseComponent {
  icons = {
    money: './assets/icons/money.svg',
  };
}
